// extracted by mini-css-extract-plugin
module.exports = {"FullWidthBlocks":"FullWidthBlocks-module__FullWidthBlocks___1lUsj","lastBox":"FullWidthBlocks-module__lastBox___9DxIX"};